"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ICancellationToken.js.map